import { render, staticRenderFns } from "./ProductNotificationReview.vue?vue&type=template&id=68780231&scoped=true&"
import script from "./ProductNotificationReview.vue?vue&type=script&lang=js&"
export * from "./ProductNotificationReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductNotificationReview.vue?vue&type=style&index=0&id=68780231&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68780231",
  null
  
)

export default component.exports